import * as firebase from "firebase";

const config = {
    apiKey: "AIzaSyD73crtTWrPifd04QUDtIxkorgsa5gHg4Q",
    authDomain: "cuminaivel2.firebaseapp.com",
    databaseURL: "https://cuminaivel2.firebaseio.com",
    projectId: "cuminaivel2",
    storageBucket: "cuminaivel2.appspot.com",
    messagingSenderId: "1296801914",
    appId: "1:1296801914:web:31d8d373c0f52add"
};

let Firebase = firebase.initializeApp(config);
Firebase.getCurrentUser = () => {
    return new Promise((resolve, reject) => {
        const unsubscribe = firebase.auth().onAuthStateChanged(user => {
            unsubscribe();
            resolve(user);
        }, reject);
    })
};

Firebase.firestore()
    .enablePersistence()
    .catch(err => console.log(err));

export default Firebase;
